module.exports = __webpack_public_path__ + "assets/img/2-2-en.dc701303.png";